import Scrollable from "../Pages/BonusUi/Scrollable";
import Toasts from "../Pages/BonusUi/Toasts";
import TreeView from "../Pages/BonusUi/TreeView";
import Accordion from "../Pages/UiKits/Accordion";
import Alert from "../Pages/UiKits/Alert";
import Avatars from "../Pages/UiKits/Avatars";
import Dropdown from "../Pages/UiKits/Dropdown";
import Grid from "../Pages/UiKits/Grid";
import HelperClasses from "../Pages/UiKits/HelperClasses";
import Lists from "../Pages/UiKits/Lists";
import Tabs from "../Pages/UiKits/Tabs";
import Popover from "../Pages/UiKits/Popover";
import Tooltip from "../Pages/UiKits/Tooltip";
import Modal from "../Pages/UiKits/Modal";
import Progress from "../Pages/UiKits/Progress";
import TagAndPills from "../Pages/UiKits/Tag&Pills";
import Typography from "../Pages/UiKits/Typography";
import ProductPage from "../Pages/Apps/Ecommerce/ProductPage";
import ProductList from "../Pages/Apps/Ecommerce/ProductList";
import AddProduct from "../Pages/Apps/Ecommerce/AddProduct";
import Product from "../Pages/Apps/Ecommerce/Product";
import ProjectList from "../Pages/Apps/Project/ProjectList";
import ProjectCreate from "../Pages/Apps/Project/ProjectCreate";
import FileManager from "../Pages/Apps/FileManager";
import General from "../Pages/Widgets/General";
import Chart from "../Pages/Widgets/Chart";
import Ecommerce from "../Pages/Dashboards/Ecommerce";
import Project from "../Pages/Dashboards/Project";
import CkEditor from "../Pages/Miscellaneous/Editors/CkEditor";
import MdeEditor from "../Pages/Miscellaneous/Editors/MdeEditor";
import AceCodeEditor from "../Pages/Miscellaneous/Editors/AceCodeEditor";
import SupportTicket from "../Pages/Miscellaneous/SupportTicket";
import Default from "../Pages/Dashboards/Default";
import Timeline from "../Pages/BonusUi/Timeline";
import FlagIcons from "../Pages/Icons/FlagIcons";
import FontAwesomeIcon from "../Pages/Icons/FontAwesomeIcon";
import IcoIcon from "../Pages/Icons/IcoIcon";
import ThemifyIcon from "../Pages/Icons/ThemifyIcon";
import FeatherIcons from "../Pages/Icons/FeatherIcons";
import GalleryGrid from "../Pages/Miscellaneous/Gallery/GalleryGrid";
import GalleryDescription from "../Pages/Miscellaneous/Gallery/GalleryDescription";
import MasonryGallery from "../Pages/Miscellaneous/Gallery/MasonryGallery";
import MasonryGalleryDescription from "../Pages/Miscellaneous/Gallery/MasonryGalleryDescription";
import ImageHoverEffects from "../Pages/Miscellaneous/Gallery/ImageHoverEffects";
import BlogDetails from "../Pages/Miscellaneous/Blog/BlogDetails";
import BlogSingle from "../Pages/Miscellaneous/Blog/BlogSingle";
import AddPost from "../Pages/Miscellaneous/Blog/AddPost";
import BasicInit from "../Pages/Tables/DataTables/BasicInit";
import AdvanceInit from "../Pages/Tables/DataTables/AdvanceInit";
import APIDataTables from "../Pages/Tables/DataTables/APIDataTables";
import DataSource from "../Pages/Tables/DataTables/DataSource";
import SamplePage from "../Pages/Pages/SamplePage";
import FormWizard2 from "../Pages/Forms/FormLayout/FormWizard2";
import BasicTables from "../Pages/Tables/ReactstrapTables/BasicTables";
import TableComponents from "../Pages/Tables/ReactstrapTables/TableComponents";
import FormWizard1 from "../Pages/Forms/FormLayout/FormWizard1";
import TwoFactor from "../Pages/Forms/FormLayout/TwoFactor";
import ImageCropper from "../Pages/BonusUi/ImageCropper";
import BasicCard from "../Pages/BonusUi/BasicCard";
import CreativeCard from "../Pages/BonusUi/CreativeCard";
import Paginations from "../Pages/BonusUi/Paginations";
import Breadcrumb from "../Pages/BonusUi/Breadcrumb";
import RangeSlider from "../Pages/BonusUi/RangeSlider";
import SweetAlert from "../Pages/BonusUi/SweetAlert";
import Carousel from "../Pages/BonusUi/Carousel";
import Ribbons from "../Pages/BonusUi/Ribbons";
import Rating from "../Pages/BonusUi/Rating";
import Dropzone from "../Pages/BonusUi/Dropzone";
import Tour from "../Pages/BonusUi/Tour";
import PrivateChat from "../Pages/Apps/Chat/PrivateChat";
import GroupChat from "../Pages/Apps/Chat/GroupChat";
import UserProfile from "../Pages/Apps/Users/UserProfile";
import EditProfile from "../Pages/Apps/Users/EditProfile";
import UserCards from "../Pages/Apps/Users/UserCards";
import SocialApp from "../Pages/Apps/SocialApp";
import SearchResult from "../Pages/Apps/SearchResult";
import Tasks from "../Pages/Apps/Tasks";
import Calendar from "../Pages/Apps/Calendar";
import ToDo from "../Pages/Apps/ToDo";
import Bookmarks from "../Pages/Apps/Bookmarks";
import Contacts from "../Pages/Apps/Contacts";
import EmailApplication from "../Pages/Apps/Email/EmailApplication";
import EmailCompose from "../Pages/Apps/Email/EmailCompose";
import LetterBox from "../Pages/Apps/Email/LetterBox";
import Invoice1 from "../Pages/Apps/Ecommerce/Invoices/Invoice1";
import Invoice2 from "../Pages/Apps/Ecommerce/Invoices/Invoice2";
import Invoice3 from "../Pages/Apps/Ecommerce/Invoices/Invoice3";
import Invoice4 from "../Pages/Apps/Ecommerce/Invoices/Invoice4";
import Cart from "../Pages/Apps/Ecommerce/Cart";
import Wishlist from "../Pages/Apps/Ecommerce/Wishlist";
import Checkout from "../Pages/Apps/Ecommerce/Checkout";
import Pricing from "../Pages/Apps/Ecommerce/Pricing";
import AllReports from "../Components/Reports/AllReports";
import Invoice5 from "../Pages/Apps/Ecommerce/Invoices/Invoice5";
import Invoice6 from "../Pages/Apps/Ecommerce/Invoices/Invoice6";
import PaymentDetails from "../Pages/Apps/Ecommerce/PaymentDetails";
import OrderHistory from "../Pages/Apps/Ecommerce/OrderHistory";
import Faq from "../Pages/Miscellaneous/Faq";
import Knowledgebase from "../Pages/Miscellaneous/Knowledgebase";
import LearningList from "../Pages/Miscellaneous/Learning/LearningList";
import DetailedCourse from "../Pages/Miscellaneous/Learning/DetailedCourse";
import CardsView from "../Pages/Miscellaneous/JobSearch/CardsView";
import ListView from "../Pages/Miscellaneous/JobSearch/ListView";
import JobDetails from "../Pages/Miscellaneous/JobSearch/JobDetails";
import ApplyJobs from "../Pages/Miscellaneous/JobSearch/ApplyJobs";
import GoogleMaps from "../Pages/Miscellaneous/Maps/GoogleMaps";
import LeafletMap from "../Pages/Miscellaneous/Maps/LeafletMap";
import InputMask from "../Pages/Forms/FormControls/InputMask";
import MegaOptions from "../Pages/Forms/FormControls/MegaOptions";
import Datepicker from "../Pages/Forms/FormWidgets/Datepicker";
import GoogleChart from "../Pages/Charts/GoogleChart";
import ChartJsChart from "../Pages/Charts/ChartJsChart";
import FormValidation from "../Pages/Forms/FormControls/FormValidation";
import InputGroups from "../Pages/Forms/FormControls/InputGroups";
import Touchspin from "../Pages/Forms/FormWidgets/Touchspin";
import Switch from "../Pages/Forms/FormWidgets/Switch";
import Typeahead from "../Pages/Forms/FormWidgets/Typeahead";
import Clipboard from "../Pages/Forms/FormWidgets/Clipboard";
import BaseInputs from "../Pages/Forms/FormControls/BaseInputs";
import CheckboxAndRadio from "../Pages/Forms/FormControls/Checkbox&Radio";
import WhetherIcon from "../Pages/Icons/WhetherIcon";
import DefaultStyle from "../Pages/Buttons/DefaultStyle";
import ButtonGroup from "../Pages/Buttons/ButtonGroup";
import ApexChart from "../Pages/Charts/ApexChart";
// import Table1, { Table2, Table3, Table4, Table5 } from "../Components/Widgets/General/Tables";
import FirstLoader from "../Auth/FirstLoader";
import Profile from "../Pages/Widgets/Chart";
import Debug from "../Pages/Dashboards/Debug/Debug";
import Attendance from "../Pages/Dashboards/Attendance/Attendance";
import OlaMapPage from "../Pages/Dashboards/Attendance/OlaMapPage";
import EffertReport from "../Components/Reports/EffortReport";
import DARReport from "../Components/Reports/DARReport";
import OVPReport from "../Components/Reports/OVPReport";
import DailyEffortReport from "../Components/Reports/DailyEffortReport";
import DARReports from "../Components/Reports/DarReports";
import UserProfiles from "../Components/Apps/Users/UserProfiles";
import ProfileTabs from "../Components/ProfileTabs";
import EmployeesList from "../Components/Dashboards/Employees/EmployeesList";
import FtpImport from "../Components/Dashboards/FTP/FtpImport";
import FtpExport from "../Components/Dashboards/FTP/FtpExport";
import FtpImportLogs from "../Components/Dashboards/FTP/FtpImportLogs";
import FtpExportLogs from "../Components/Dashboards/FTP/FtpExportLogs";
import FTPTabs from "../Components/Dashboards/FTP";
import ApprovalTabs from "../Components/Dashboards/ApprovalTabs";
import MTPBigCalendar from "../Components/Dashboards/ApprovalTabs/MTPBigCalendar";
import LeaveDashboard from "../Components/Dashboards/ApprovalTabs/LeaveDashboard";
import Expenses from "../Components/Dashboards/ApprovalTabs/Expenses";
import ExpenseOverview from "../Components/Dashboards/ApprovalTabs/ExpenseOverview";
import SGPIOutReports from "../Components/Reports/SGPIOutReports";
import RCPASkuSummary from "../Components/Reports/RCPASkuSummery";
import PodReport from "../Components/Reports/PodReport";
import JwReport from "../Components/Reports/JwReport";
import ExpensesSummary from "../Components/Reports/ExpensesSummary";
import ExpenseStatus from "../Components/Reports/ExpenseStatus";
import EmployeeAttendaceReport from "../Components/Reports/EmployeeAttendaceReport";
import MTPSummary from "../Components/Reports/MTPSummary";
import TeamAttendanceReport from "../Components/Reports/TeamAttendanceReport";
import LeaveBalanceReport from "../Components/Reports/LeaveBalanceReport";
import SupportCaptureSummary from "../Components/Reports/SupportCaptureSummary";
import TargetVsAchievement from "../Components/Reports/TargetVsAchievement";
import CustomerCentral from "../Components/Dashboards/CustomerCentral";
import SalesInsights from "../Components/Dashboards/SalesInsights";
import SalesAgreement from "../Components/Dashboards/SalesAgreement";
import CommonReport from "../Components/Reports/CommonReport";
import DailyJointWorking from "../Components/Reports/AllKPIs/DailyJointWorking";
import ReportsDashboard from "../Components/Dashboards/ReportsDashboard/index";
import MasReportV3 from "../Components/Reports/MasReportV3";
import OutletViewReport from "../Components/Reports/OutletViewReport";
import JwReportV2 from "../Components/Reports/JwReportV2";

export const routes = [
  { path: `/components/ui-kits/typography`, element: <Typography /> },
  { path: `/components/ui-kits/avatars`, element: <Avatars /> },
  { path: `/components/ui-kits/helper-classes`, element: <HelperClasses /> },
  { path: `/components/bonus-ui/scrollable`, element: <Scrollable /> },
  { path: `/components/bonus-ui/tree`, element: <TreeView /> },
  { path: `/components/bonus-ui/toasts`, element: <Toasts /> },
  { path: `/components/ui-kits/tabs`, element: <Tabs /> },
  { path: `/components/ui-kits/lists`, element: <Lists /> },
  { path: `/components/ui-kits/dropdown`, element: <Dropdown /> },
  { path: `/components/ui-kits/accordion`, element: <Accordion /> },
  { path: `/components/ui-kits/alert`, element: <Alert /> },
  { path: `/components/ui-kits/popover`, element: <Popover /> },
  { path: `/components/ui-kits/tooltip`, element: <Tooltip /> },
  { path: `/components/ui-kits/modal`, element: <Modal /> },
  { path: `/components/ui-kits/grid`, element: <Grid /> },
  { path: `/components/ui-kits/tag-pills`, element: <TagAndPills /> },
  { path: `/components/ui-kits/progress-bar`, element: <Progress /> },
  { path: `/applications/ecommerce/product-page`, element: <ProductPage /> },
  { path: `/applications/ecommerce/product-list`, element: <ProductList /> },
  { path: `/applications/ecommerce/add-products`, element: <AddProduct /> },
  { path: `/applications/ecommerce/product`, element: <Product /> },
  { path: `/applications/project/project-list`, element: <ProjectList /> },
  { path: `/applications/project/create-project`, element: <ProjectCreate /> },
  { path: `/applications/file-manager`, element: <FileManager /> },
  { path: `/debug`, element: <Debug /> },
  // { path: `/widgets/table1`, element: <Table1/> },
  // { path: `/widgets/table2`, element: <Table2 /> },
  // { path: `/widgets/table3`, element: <Table3 /> },
  // { path: `/widgets/table4`, element: <Table4 /> },
  // { path: `/widgets/table5`, element: <Table5 /> },
  { path: `/widgets/chart-widget`, element: <Chart /> },
  { path: `/profile`, element: <EditProfile /> },
  { path: `/dashboard/ecommerce`, element: <Ecommerce /> },
  { path: `/dashboard/project`, element: <Project /> },
  { path: `/miscellaneous/editors/ck-editor`, element: <CkEditor /> },
  { path: `/miscellaneous/editors/mde-editor`, element: <MdeEditor /> },
  {
    path: `/miscellaneous/editors/ace-code-editor`,
    element: <AceCodeEditor />,
  },
  { path: `/miscellaneous/support-ticket`, element: <SupportTicket /> },
  { path: `/admin`, element: <Attendance /> },
  { path: `/olaMap`, element: <OlaMapPage /> },
  { path: `/effortReport`, element: <EffertReport /> },
  { path: `/supportCaptureSummary`, element: <SupportCaptureSummary /> },
  { path: `/darReport`, element: <DARReports /> },
  { path: `/userDetails`, element: <UserProfiles /> },
  { path: `/newProfile`, element: <ProfileTabs /> },
  { path: `/employees`, element: <EmployeesList /> },
  { path: `/ftpImport`, element: <FTPTabs /> },
  { path: `/ftpImportLogs`, element: <FtpImportLogs /> },
  { path: `/ftpExportLogs`, element: <FtpExportLogs /> },
  { path: `/ftpExport`, element: <FtpExport /> },
  { path: `/Approvals`, element: <ApprovalTabs /> },
  { path: `/reportsDashboard`, element: <ReportsDashboard /> },
  { path: "/mtpcalendarbig", element: <MTPBigCalendar /> },
  { path: "/leaveDashboard", element: <LeaveDashboard /> },
  { path: "/expenses", element: <Expenses /> },
  { path: "/expenses/expenseoverview", element: <ExpenseOverview /> },
  { path: `/sgpiOutReport`, element: <SGPIOutReports /> },
  // { path: `/ovpReport`, element: <OVPReport /> },
  { path: "/ovpReport/:positionId", element: <OVPReport /> },
  { path: "/dailyEffortReport", element: <DailyEffortReport /> },
  // { path: '/darReport/:positionId', element: <DARReport /> },
  { path: `/components/bonus-ui/timeline`, element: <Timeline /> },
  { path: `/components/icons/flag-icon`, element: <FlagIcons /> },
  { path: `/components/icons/font-awesome`, element: <FontAwesomeIcon /> },
  { path: `/components/icons/ico-icon`, element: <IcoIcon /> },
  { path: `/components/icons/themify-icon`, element: <ThemifyIcon /> },
  { path: `/components/icons/feather-icon`, element: <FeatherIcons /> },
  { path: `/miscellaneous/gallery/grid-gallery`, element: <GalleryGrid /> },
  {
    path: `/miscellaneous/gallery/grid-gallery-description`,
    element: <GalleryDescription />,
  },
  {
    path: `/miscellaneous/gallery/masonry-gallery`,
    element: <MasonryGallery />,
  },
  {
    path: `/miscellaneous/gallery/masonry-gallery-description`,
    element: <MasonryGalleryDescription />,
  },
  {
    path: `/miscellaneous/gallery/gallery-hover`,
    element: <ImageHoverEffects />,
  },
  { path: `/miscellaneous/blog/blog-detail`, element: <BlogDetails /> },
  { path: `/miscellaneous/blog/blog-single`, element: <BlogSingle /> },
  { path: `/miscellaneous/blog/add-post`, element: <AddPost /> },
  { path: `/table/data-tables/basic-init`, element: <BasicInit /> },
  { path: `/table/data-tables/advance-init`, element: <AdvanceInit /> },
  { path: `/table/data-tables/api`, element: <APIDataTables /> },
  { path: `/table/data-tables/data-sources`, element: <DataSource /> },
  { path: `/pages/sample-page`, element: <SamplePage /> },
  { path: `/forms/form-layout/form-wizard-2`, element: <FormWizard2 /> },
  { path: `/table/reactstrap-tables/basic-table`, element: <BasicTables /> },
  {
    path: `/table/reactstrap-tables/table-components`,
    element: <TableComponents />,
  },
  { path: `/forms/form-layout/form-wizard-1`, element: <FormWizard1 /> },
  { path: `/forms/form-layout/two-factor`, element: <TwoFactor /> },
  { path: `/components/bonus-ui/image-cropper`, element: <ImageCropper /> },
  { path: `/components/bonus-ui/basic-card`, element: <BasicCard /> },
  { path: `/components/bonus-ui/creative-card`, element: <CreativeCard /> },
  { path: `/components/bonus-ui/pagination`, element: <Paginations /> },
  { path: `/components/bonus-ui/breadcrumb`, element: <Breadcrumb /> },
  { path: `/components/bonus-ui/range-slider`, element: <RangeSlider /> },
  { path: `/components/bonus-ui/sweet-alert-2`, element: <SweetAlert /> },
  { path: `/components/bonus-ui/carousel`, element: <Carousel /> },
  { path: `/components/bonus-ui/ribbons`, element: <Ribbons /> },
  { path: `/components/bonus-ui/rating`, element: <Rating /> },
  { path: `/components/bonus-ui/dropzone`, element: <Dropzone /> },
  { path: `/components/bonus-ui/tour`, element: <Tour /> },
  { path: `/applications/chat/chat-private`, element: <PrivateChat /> },
  { path: `/applications/chat/chat-group`, element: <GroupChat /> },
  { path: `/applications/users/user-profile`, element: <UserProfile /> },
  { path: `/applications/users/edit-profile`, element: <EditProfile /> },
  { path: `/applications/users/user-cards`, element: <UserCards /> },
  { path: `/applications/social-app`, element: <SocialApp /> },
  { path: `/applications/search`, element: <SearchResult /> },
  { path: `/applications/task`, element: <Tasks /> },
  { path: `/applications/calendar-basic`, element: <Calendar /> },
  { path: `/applications/to-do`, element: <ToDo /> },
  { path: `/applications/bookmark`, element: <Bookmarks /> },
  { path: `/applications/contacts`, element: <Contacts /> },
  { path: `/applications/email/email-app`, element: <EmailApplication /> },
  { path: `/applications/email/email-compose`, element: <EmailCompose /> },
  { path: `/applications/email/letter-box`, element: <LetterBox /> },
  { path: `/invoice/invoice-1`, element: <Invoice1 /> },
  { path: `/invoice/invoice-2`, element: <Invoice2 /> },
  { path: `/invoice/invoice-3`, element: <Invoice3 /> },
  { path: `/invoice/invoice-4`, element: <Invoice4 /> },
  { path: `/invoice/invoice-5`, element: <Invoice5 /> },
  { path: `/invoice/invoice-6`, element: <Invoice6 /> },
  { path: `/applications/ecommerce/cart`, element: <Cart /> },
  { path: `/applications/ecommerce/wishlist`, element: <Wishlist /> },
  { path: `/applications/ecommerce/checkout`, element: <Checkout /> },
  { path: `/applications/ecommerce/pricing`, element: <Pricing /> },
  {
    path: `/applications/ecommerce/payment-details`,
    element: <PaymentDetails />,
  },
  { path: `/applications/ecommerce/order-history`, element: <OrderHistory /> },
  { path: `/fieldPerformance`, element: <AllReports /> },
  { path: `/customerCentral`, element: <CustomerCentral /> },
  { path: `/salesInsights`, element: <SalesInsights /> },
  { path: `/salesAgreement`, element: <SalesAgreement /> },
  { path: `/miscellaneous/faq`, element: <Faq /> },
  { path: `/miscellaneous/knowledgebase`, element: <Knowledgebase /> },
  {
    path: `/miscellaneous/learning/learning-list-view`,
    element: <LearningList />,
  },
  {
    path: `/miscellaneous/learning/course-details`,
    element: <DetailedCourse />,
  },
  { path: `/miscellaneous/job-search/job-cards-view`, element: <CardsView /> },
  { path: `/miscellaneous/job-search/job-list-view`, element: <ListView /> },
  { path: `/miscellaneous/job-search/job-details`, element: <JobDetails /> },
  { path: `/miscellaneous/job-search/job-apply`, element: <ApplyJobs /> },
  { path: `/miscellaneous/maps/google-map`, element: <GoogleMaps /> },
  { path: `/miscellaneous/maps/leaflet-map`, element: <LeafletMap /> },
  { path: `/forms/form-controls/input-mask`, element: <InputMask /> },
  { path: `/forms/form-controls/mega-options`, element: <MegaOptions /> },
  { path: `/forms/form-widgets/datepicker`, element: <Datepicker /> },
  { path: `/components/charts/chart-google`, element: <GoogleChart /> },
  { path: `/components/charts/chartjs`, element: <ChartJsChart /> },
  { path: `/forms/form-controls/form-validation`, element: <FormValidation /> },
  { path: `/forms/form-controls/input-group`, element: <InputGroups /> },
  { path: `/forms/form-widgets/touchspin`, element: <Touchspin /> },
  { path: `/forms/form-widgets/switch`, element: <Switch /> },
  { path: `/forms/form-widgets/typeahead`, element: <Typeahead /> },
  { path: `/forms/form-widgets/clipboard`, element: <Clipboard /> },
  { path: `/forms/form-controls/base-input`, element: <BaseInputs /> },
  {
    path: `/forms/form-controls/radio-checkbox-control`,
    element: <CheckboxAndRadio />,
  },
  { path: `/components/icons/whether-icon`, element: <WhetherIcon /> },
  { path: `/components/buttons/default`, element: <DefaultStyle /> },
  { path: `/components/buttons/button-group`, element: <ButtonGroup /> },
  { path: `/components/charts/chart-apex`, element: <ApexChart /> },
  { path: `/rcpaSkuSummary`, element: <RCPASkuSummary /> },
  { path: `/podReport`, element: <PodReport /> },
  { path: `/jwReport`, element: <JwReport /> },
  { path: `/dailyjwReport`, element: <DailyJointWorking/> },
  { path: `/expensesSummary`, element: <ExpensesSummary /> },
  { path: `/expensesStatus`, element: <ExpenseStatus /> },
  { path: `/employeeAttendaceReport`, element: <EmployeeAttendaceReport /> },
  { path: `/mtpSummary`, element: <MTPSummary /> },
  { path: `/teamAttendanceReport`, element: <TeamAttendanceReport /> },
  { path: `/leaveBalanceReport`, element: <LeaveBalanceReport /> },
  { path: `/TargetVsAchievement`, element: <TargetVsAchievement /> },
  { path: `/masReportV3`, element: <MasReportV3 /> },
  { path: `/outletViewReport`, element: <OutletViewReport /> },
  { path: `/jwReportV2`, element: <JwReportV2 /> },
  { path: "/reports/common/:reportType", element: <CommonReport /> },
];
